<template>
  <div>
    <a-switch-field
      varName="offline_access"
      varLabel="Offline Access"
      :varRequired="true"
      :varInitial="data.offline_access"
      :formLayout="formLayout"
      :size="size"
      description="Enable offline access to issue refresh token (depending on grant types)"
    />
    <a-select-field
      varName="allowed_claims_id_token"
      varLabel="ID Token Allowed Claims"
      :varRequired="true"
      :varInitial="data.allowed_claims_id_token"
      :formLayout="formLayout"
      :size="size"
      :varOptions="claims"
      type="array"
      varMode="multiple"
      v-show="data.is_first_party"
      description="This option is only enabled for first party clients"
    />
    <a-select-field
      varName="allowed_claims_userinfo"
      varLabel="Userinfo Allowed Claims"
      :varRequired="true"
      :varInitial="data.allowed_claims_userinfo"
      :formLayout="formLayout"
      :size="size"
      :varOptions="claims"
      type="array"
      varMode="multiple"
      v-show="data.is_first_party"
      description="This option is only enabled for first party clients"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      claims: [
        'openid',
        'profile',
        'email',
        'phone',
        'address',
        'roles',
        'permissions',
        'orgs'
      ]
    };
  },
  components: {},
  props: {
    formLayout: String,
    size: String,
    data: Object,
    options: Object
  }
};
</script>
